const AFRAME = window.AFRAME;
const THREE = window.AFRAME.THREE;

var debug = AFRAME.utils.debug;

let placed = false;
let isAnimating = false;
let isAnimationFinished = false;
let model;
let isPlaying = false;

window.isAdMounted = false;

const ensureMaterialArray = (material) => {
    if (!material) {
        return []
    }
    if (Array.isArray(material)) {
        return material
    }
    if (material.materials) {
        return material.materials
    }
    return [material]
}

const applyEnvMap = (mesh, envMap) => {
    if (!mesh) return
    mesh.traverse((node) => {
        if (!node.isMesh) {
            return
        }
        const meshMaterials = ensureMaterialArray(node.material)
        meshMaterials.forEach((material) => {
            if (material && !('envMap' in material)) return
            material.envMap = envMap
            material.needsUpdate = true
        })
    });
}

/*-----COMPONENTS-----*/

AFRAME.registerComponent('tap-link', {
    init() {
        const el = this.el;
        console.log('registered on: ' + el.id);
        el.classList.add('cantap');

        el.addEventListener('click', () => {
            window.open(el.getAttribute('data-url'), '_blank');
        });
    }
});

AFRAME.registerComponent('model-opacity', {
    schema: {
        default: 1.0
    },

    init: function () {
        this.el.addEventListener('model-loaded', this.update.bind(this));
    },

    update: function () {
        var mesh = this.el.getObject3D('mesh');
        var data = this.data;
        if (!mesh) { return; }
        mesh.traverse(function (node) {
            if (node.isMesh) {
                node.material.opacity = data;
                node.material.transparent = data < 1.0;
                node.material.needsUpdate = true;
            }
        });
    }
});

AFRAME.registerComponent('tap-place-video', {
    init() {
        this.raycaster = new THREE.Raycaster()
        this.camera = document.getElementById('camera')
        this.threeCamera = this.camera.getObject3D('camera')
        this.ground = document.getElementById('ground')
        this.ring = document.getElementById('ring')
        this.video = document.getElementById('video');
        this.cta = document.getElementById('cta')

        // 2D coordinates of the raycast origin, in normalized device coordinates (NDC)---X and Y
        // components should be between -1 and 1.  Here we want the cursor in the center of the screen.
        this.rayOrigin = new THREE.Vector2(0, 0)
        this.cursorLocation = new THREE.Vector3(0, 0, 0)

        this.presenter = document.getElementById('video-3d')

        const sceneEl = this.el.sceneEl

        const clickHandler = (event) => {

            console.log('CLICKED');

            if (placed === true) {
                return
            }

            placed = true
            document.body.removeEventListener('click', clickHandler, false);

            this.ring.setAttribute('visible', 'false');
            this.presenter.setAttribute('material', 'opacity:1');
            this.cta.setAttribute('material', 'opacity:1');
            this.presenter.setAttribute('src', '#video');
            document.getElementById('video').play();

            // const presenterScale = this.presenter.getAttribute('scale')
            const ringPos = this.ring.object3D.position
            // should be 0.5 but the presenter has padding in video
            // const yOffsetScalar = 0.35
            // const presenterYOffset = presenterScale.y * 25 * yOffsetScalar

            this.presenter.setAttribute('position', ringPos.x + ' ' + (ringPos.y + window.schema.elements.videoOffsetTop) + ' ' + ringPos.z);
            // document.getElementById('inst').style.display = 'none';
            if (document.querySelector('.video-instruction')) document.querySelector('.video-instruction').style.display = 'none'; 
        }

        console.log('LISTEN TO CLICKS');
        setTimeout(function () {
            sceneEl.addEventListener('touchstart', clickHandler)
        }, 500)
    },
    tick() {
        if (placed) {

            const camPos = this.camera.getAttribute('position')
        } else {

            // Raycast from camera to 'ground'
            this.raycaster.setFromCamera(this.rayOrigin, this.threeCamera)
            const intersects = this.raycaster.intersectObject(this.ground.object3D, true)
            if (intersects.length > 0) {
                const [intersect] = intersects
                this.cursorLocation = intersect.point
            }
            // this.presenter.object3D.position.lerp(this.cursorLocation, 0.4)
            // this.presenter.object3D.position.y = schema.elements.videoOffsetTop;
            this.presenter.setAttribute('position', this.cursorLocation.x + ' ' + (this.cursorLocation.y + window.schema.elements.videoOffsetTop) + ' ' + this.cursorLocation.z);
            this.cta.setAttribute('position', this.cursorLocation.x + ' ' + (this.cursorLocation.y + (window.schema.elements.videoOffsetTop * 0.3)) + ' ' + this.cursorLocation.z);
            this.ring.object3D.position.lerp(this.cursorLocation, 0.4)
            this.ring.object3D.rotation.y = this.threeCamera.rotation.y
        }
    },
});

AFRAME.registerComponent('tap-place-model', {
    init() {
        this.raycaster = new THREE.Raycaster()
        this.camera = document.getElementById('camera')
        this.threeCamera = this.camera.getObject3D('camera')
        this.ground = document.getElementById('ground')
        this.model = document.getElementById('model')
        this.instructions = document.getElementById('instructions');
        this.activeState = document.getElementById('active-content');
        this.video = document.getElementById('video');

        this.rayOrigin = new THREE.Vector2(0, 0)
        this.cursorLocation = new THREE.Vector3(0, 0, 0)

        model = document.getElementById('scene');

        const sceneEl = this.el.sceneEl

        const clickHandler = (event) => {

            if (placed === true) {
                return
            }

            isPlaying = true
            placed = true

            const modelScale = model.getAttribute('scale')
            // const modelGeom = model.getAttribute('geometry')
            const modelPos = this.model.object3D.position
            // should be 0.5 but the model has padding in video
            const yOffsetScalar = 0.35
            const modelYOffset = modelScale.y * yOffsetScalar

            model.object3D.position.set(modelPos.x, window.schema.elements.modelOffsetTop || 0, modelPos.z)

            this.model.setAttribute('xrextras-one-finger-rotate', '')

            if (this.model.hasAttribute('model-opacity')) {
                this.model.setAttribute('animation', 'property:model-opacity;from:' + (window.schema.elements.modelStartOpacity || 0.2) + ';to:1;dur:1000');
            }

            this.activeState.setAttribute('animation', 'property: scale;to: 1 1 1; dur: 1000; delay:1000;');

            // taxi.removeAttribute('xrextras-pinch-scale');

            document.getElementById('video').play();

            this.ground.removeAttribute('class')
        }

        setTimeout(function () {
            sceneEl.addEventListener('touchstart', clickHandler);
        }, 500)
        //}
    },
    tick() {
        if (placed) {

            // const camPos = this.camera.getAttribute('position')
            // presenter.object3D.lookAt(camPos.x, presenter.object3D.position.y, camPos.z)
        } else {

            // Raycast from camera to 'ground'
            this.raycaster.setFromCamera(this.rayOrigin, this.threeCamera)
            const intersects = this.raycaster.intersectObject(this.ground.object3D, true)
            if (intersects.length > 0) {
                const [intersect] = intersects
                this.cursorLocation = intersect.point
            }
            // this.ring.object3D.position.y = 0.1
            this.model.object3D.position.lerp(this.cursorLocation, 0.4);
            this.model.object3D.position.setY(window.schema.elements.modelOffsetTop);
            this.model.object3D.rotation.y = this.threeCamera.rotation.y
        }
    },
});

AFRAME.registerComponent('cubemap-realtime', {
    schema: {},
    init() {
        const { data } = this
        const scene = this.el.sceneEl
        const camTexture_ = new THREE.Texture()
        const refMat = new THREE.MeshBasicMaterial({
            side: THREE.DoubleSide,
            color: 0xffffff,
            map: camTexture_,
        })
        const renderTarget = new THREE.WebGLCubeRenderTarget(256, {
            format: THREE.RGBFormat,
            generateMipmaps: true,
            minFilter: THREE.LinearMipmapLinearFilter,
            encoding: THREE.sRGBEncoding,
        })
        // cubemap scene
        const cubeMapScene = new THREE.Scene()
        const cubeCamera = new THREE.CubeCamera(1, 1000, renderTarget)
        const sphere = new THREE.SphereGeometry(100, 15, 15)
        const sphereMesh = new THREE.Mesh(sphere, refMat)
        sphereMesh.scale.set(-1, 1, 1)
        sphereMesh.rotation.set(Math.PI, -Math.PI / 2, 0)
        cubeMapScene.add(sphereMesh)
        const startListen = () => {
            window.XR8.XrController.configure({ enableLighting: true })
            window.XR8.addCameraPipelineModule({
                name: 'cubemap-process',
                onUpdate: ({ frameStartResult, processCpuResult }) => {
                    cubeCamera.update(scene.renderer, cubeMapScene)
                    let { cameraTexture } = frameStartResult
                    if (processCpuResult.reality) {
                        // use the camera texture that is synced with our XrController
                        cameraTexture = processCpuResult.reality.realityTexture
                    } else if (processCpuResult.facecontroller) {
                        // use the camera texture that is synced with our FaceController
                        cameraTexture = processCpuResult.facecontroller.cameraFeedTexture
                    }
                    // force initialization
                    const texProps = scene.renderer.properties.get(camTexture_)
                    texProps.__webglTexture = cameraTexture
                },
            })
            this.el.addEventListener('model-loaded', () => {
                applyEnvMap(this.el.getObject3D('mesh'), cubeCamera.renderTarget.texture)
            })
        }
        window.XR8 ? startListen() : window.addEventListener('xrloaded', startListen)
    },
});

AFRAME.registerComponent('tap-close-video', {
    init() {
        let el = this.el;
        const vid = document.getElementById('video');
        const stopVideo = () => {
            vid.pause();
            vid.currentTime = 0;
            vid.pause();
        }

        const handleClickEvent = (e) => {
            el.parentNode.setAttribute('animation', 'property: scale; from: 1 1 1; to: 0 0 0;dur:1000;loop:once;');
            stopVideo();
        }
        this.el.addEventListener('click', handleClickEvent, true)
    },
});

AFRAME.registerComponent('tap-close', {
    init() {
        let el = this.el;
        const vid = document.getElementById('video');

        const handleClickEvent = (e) => {
            el.parentNode.setAttribute('animation', 'property: scale; from: 1 1 1; to: 0 0 0;dur:1000;loop:once;');
        }
        this.el.addEventListener('click', handleClickEvent, true)
    },
});

AFRAME.registerComponent('pulse-on-tap', {

    schema: {
        default: 3
    },

    init: function () {
        // Do something when component first attached.
        let el = this.el;

        const elScale = el.getAttribute('scale').x;
        console.log(elScale);
        console.log(this.data);

        const elScaleFactor = this.data;

        const maxScaleNumber = elScale * elScaleFactor;

        const initialScale = elScale + ' ' + elScale + ' ' + elScale;
        const maxScale = maxScaleNumber + ' ' + maxScaleNumber + ' ' + maxScaleNumber;

        el.addEventListener('click', () => {
            el.setAttribute('animation', 'property: scale; to: ' + maxScale + ';easing:easeOutElastic;dur:500;elasticity:3000;');
            setTimeout(() => {
                el.setAttribute('animation', 'property: scale; to: ' + initialScale + ';easing:easeOutElastic;dur:500;elasticity:3000;');
            }, 100);
        });
    },
});

AFRAME.registerComponent('focus-highlight', {
    schema: {},
    init() {
        this.raycaster = new THREE.Raycaster()
        this.camera = document.getElementById('camera')
        this.threeCamera = this.camera.getObject3D('camera')
        this.cursor = document.getElementById('cursor')
        this.displayImages = document.querySelectorAll('.display-img')
        this.focusLost = false

        this.rayOrigin = new THREE.Vector2(0, 0)

        this.cursorLocation = new THREE.Vector3(0, 0, 0)

        this.displayImages.forEach((img) => {
            img.addEventListener('click', () => {
                window.open(img.getAttribute('data-url'), '_blank')
            })
        })
    },
    setActive(img) {
        const cta = img.querySelector('.cta')

        img.setAttribute('data-animating', 'true')
        img.removeAttribute('animation')
        img.removeAttribute('animation__opacity')
        img.setAttribute('animation', {
            property: 'scale',
            from: '1 1 1',
            to: '1.25 1.25 1.25',
            dur: 500,
        })

        img.setAttribute('animation__opacity', {
            property: 'material.opacity',
            from: '0.4',
            to: '1',
            dur: 500,
        })

        cta.removeAttribute('animation')
        cta.removeAttribute('animation__opacity')
        cta.setAttribute('animation', {
            property: 'scale',
            from: '0.001 0.001 0.001',
            to: '1 1 1',
            dur: 500,
            delay: 250,
        })

        cta.setAttribute('animation__opacity', {
            property: 'material.opacity',
            from: '0.4',
            to: '1',
            dur: 500,
            delay: 250,
        })
    },
    removeActive(img) {
        const cta = img.querySelector('.cta')

        img.setAttribute('data-animating', 'false')
        img.removeAttribute('animation')
        img.removeAttribute('animation__opacity')
        img.setAttribute('animation', {
            property: 'scale',
            from: '1.25 1.25 1.25',
            to: '1 1 1',
            dur: 500,
        })

        img.setAttribute('animation__opacity', {
            property: 'material.opacity',
            from: '1',
            to: '0.4',
            dur: 500,
        })

        cta.removeAttribute('animation')
        cta.removeAttribute('animation__opacity')
        cta.setAttribute('animation', {
            property: 'scale',
            from: '1 1 1',
            to: '0.001 0.001 0.001',
            dur: 500,
        })

        cta.setAttribute('animation__opacity', {
            property: 'material.opacity',
            from: '1',
            to: '0.4',
            dur: 500,
        })
    },
    tick() {
        this.raycaster.setFromCamera(this.rayOrigin, this.threeCamera)

        this.displayImages.forEach((img) => {
            const intersects = this.raycaster.intersectObject(img.object3D, true)

            if (intersects.length > 0 && img.hasAttribute('data-animating')) {
                if (img.getAttribute('data-animating') === 'true') return

                if (!this.focusLost) {
                    this.focusLost = true
                    const initialFocus = document.getElementById('initial-focal')
                    this.setActive(initialFocus)
                    return
                }

                this.setActive(img)
            } else if (intersects.length === 0 && img.hasAttribute('data-animating')) {
                if (img.getAttribute('data-animating') === 'false') return
                this.removeActive(img)
            }
        })
    },
});
